import classNames from 'classnames'
import { memo, useCallback } from 'react'
import { FiMic } from 'react-icons/fi'
import { useShallow } from 'zustand/react/shallow'
import { useTranslate } from '../../../../../../hooks/language/use-translate'
import { useGetMyProfileMini } from '../../../../../../hooks/queries/profile/use-get-my-profile-mini'
import { useGlobalStore } from '../../../../../../store/global-store'
import { useGetDataSeats } from '../use-get-data-seats'

export const SelectAll = memo(() => {
  const { streamerId, typeLive, userIdToSendGift, isSelectedAll } =
    useGlobalStore(
      useShallow((state) => ({
        // live: state.live,
        streamerId: state.liveUserId,
        typeLive: state.typeLive,
        userIdToSendGift: state.userIdToSendGift,
        isSelectedAll: state.isSelectedAll,
      })),
    )

  const { user: userGlobal } = useGetMyProfileMini()

  const { translate } = useTranslate()

  const { dataSeats } = useGetDataSeats()

  const handleSelectAll = useCallback(() => {
    // NUNCA incluir a si mesmo: o backend rejeita o lote inteiro com
    // cannot_gift_yourself. Vale pro host (streamerId === meu id) e pro viewer
    // sentado num seat.
    const myId = Number(userGlobal?.id)
    const notMe = (id: unknown) =>
      id != null && Number.isFinite(Number(id)) && Number(id) !== myId

    if (!typeLive?.includes('multi')) {
      return useGlobalStore.setState(() => {
        const data = new Set<number>()

        if (notMe(streamerId)) data.add(Number(streamerId))
        if (notMe(userIdToSendGift)) data.add(Number(userIdToSendGift))

        return {
          usersToGift: data,
          isSelectedAll: true,
        }
      })
    }

    const newSet = new Set<number>()
    // o host (streamerId) entra na leva de "todos" (a não ser que eu seja o host)
    if (notMe(streamerId)) newSet.add(Number(streamerId))
    dataSeats.forEach((user) => {
      if (notMe(user?.userId)) newSet.add(Number(user?.userId))
    })

    useGlobalStore.setState({ usersToGift: newSet, isSelectedAll: true })
  }, [streamerId, dataSeats, userIdToSendGift, userGlobal?.id, typeLive])

  const handleClearUsersToGift = useCallback(() => {
    useGlobalStore.setState({ isSelectedAll: false })
    useGlobalStore.setState({ usersToGift: new Set() })
  }, [])

  return (
    typeLive?.includes('multi') && (
      <div
        className={classNames(
          'rounded-full flex h-8 px-3 items-center justify-center gap-1 text-xs font-semibold whitespace-nowrap transition-colors',
          {
            'bg-linear-to-r from-hug-purple to-hug-lilac text-white shadow-[0_2px_8px_rgba(155,48,230,0.45)]':
              isSelectedAll,
            'bg-white/10 text-white/80': !isSelectedAll,
          },
        )}
        onClick={isSelectedAll ? handleClearUsersToGift : handleSelectAll}
      >
        <FiMic className="text-sm" />
        <span>{translate('modal-gifts-all')}</span>
      </div>
    )
  )
})
